import webApi from '../../webapi';

const getOrcamentoCliente = async (codOrcamento) => {
    const data = await webApi.get(`orcamentos/${codOrcamento}/cliente`);
    return data;
};

const getOrcamento = async () => {
    const data = await webApi.get('orcamentos');
    return data;
};

const putPropostaRejeitada = async (codOrcamento) => {
    await webApi.put(`/Orcamentos/${codOrcamento}/proposta-rejeitada`);
};

const putPedidoAberto = async (codOrcamento) => {
    await webApi.put(`orcamentos/${codOrcamento}/pedido-aberto`);
};

const putPedidoSolicitado = async (codOrcamento, params) => {
    try {
        const data = await webApi.put(
            `orcamentos/${codOrcamento}/pedido-solicitado`,
            { observacaoPedido: params }
        );
        return data;
    } catch (error) {
        return null;
    }
};

const putPedidoFechar = async (codOrcamento, params) => {
    try {
        const data = await webApi.put(
            `Orcamentos/${codOrcamento}/fechar-pedido`,
            { Observation: params }
        );
        return data;
    } catch (error) {
        return null;
    }
};

export {
    getOrcamentoCliente,
    getOrcamento,
    putPropostaRejeitada,
    putPedidoAberto,
    putPedidoSolicitado,
    putPedidoFechar,
};
